/* Brain Age LP: the GA4 events the CTA map asks for (QA section), and a keyboard fix for the shared product card.
   Loaded by the hero; runs once.

   GA4 events go to the dataLayer the way the site's own do ({event: "faqAccordionOpen", ...} in the theme bundle), so
   GTM (GTM-NMH55ND) sends them once it has a GA4 event tag for each name:
   - brain_age_cta_click {location, label, destination_type}: a link or button in the page sections. Not the model tabs,
     swatches, slide dots, FAQ questions or Add to Cart (they have their own events, or none).
   - brain_age_model_select {model}: a model tab that wasn't selected yet.
   - faq_open {question}: an FAQ question opened.
   add_to_cart is not pushed here: Shopify's own tracking sends it, and the CTA map says not to send it twice.

   Product card (sections/premium-product-section.liquid, used on other pages too, so fixed from here): switching model
   swaps two copies of the card. The copy that had focus is hidden after the swap, so keyboard focus, and VoiceOver's
   cursor, fell back to the top of the page. Focus moves to the same tab in the copy that is now shown. */
(function () {
  if (window.baPageReady) return;
  window.baPageReady = true;

  // section id "shopify-section-template--…__hero" -> the CTA map's location names
  var LOCATION = { hero: 'hero', quote: 'quote', chart: 'research', tiles: 'tiles', stats: 'stats', app: 'what_you_see',
                   product: 'device_selection', faq: 'faq', cta: 'bottom_banner' };

  function push(data) { (window.dataLayer = window.dataLayer || []).push(data); }
  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function locationOf(el) {
    var s = el.closest('[id^="shopify-section-template"]');
    if (!s) return null;
    var key = s.id.split('__').pop();
    return LOCATION[key] || key;
  }
  function destinationType(a) {
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#') return 'anchor';
    var url;
    try { url = new URL(href, location.href); } catch (e) { return 'other'; }
    if (/(^|\.)mobile\.choosemuse\.com$|apps\.apple\.com$|play\.google\.com$/.test(url.hostname)) return 'app';
    if (!/(^|\.)choosemuse\.com$/.test(url.hostname) && url.hostname !== location.hostname) return 'external';
    if (/^\/products\//.test(url.pathname)) return 'product';
    return 'internal';
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a[href], button');
    if (!el) return;
    var where = locationOf(el);
    if (!where) return;
    if (el.classList.contains('pps-tab')) {
      if (el.getAttribute('aria-selected') !== 'true') push({ event: 'brain_age_model_select', model: text(el).replace(/\s+Bundle$/i, '') });
      return;
    }
    if (el.tagName !== 'A' || el.closest('.pps-swatch, summary')) return; // Add to Cart, dots, swatches, FAQ: not CTA clicks
    // label: the link's accessible name when it has one ("Learn more about Brain Recharge"), else its text
    push({ event: 'brain_age_cta_click', location: where, label: el.getAttribute('aria-label') || text(el), destination_type: destinationType(el) });
  }, true);

  // FAQ: <details> fires "toggle" on itself only, so listen in the capture phase
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.tagName !== 'DETAILS' || !d.open || !locationOf(d)) return;
    var q = d.querySelector('summary');
    push({ event: 'faq_open', question: q ? text(q) : '' });
  }, true);

  // Stat tiles: on phones the row scrolls sideways. A row that scrolls needs a Tab stop and a name, or a keyboard can't
  // scroll it (axe scrollable-region-focusable); added only while it actually scrolls, so desktop gets no extra stop.
  function tiles() {
    document.querySelectorAll('[id^="shopify-section-template"] .ba-tiles').forEach(function (row) {
      var scrolls = row.scrollWidth > row.clientWidth + 1;
      if (scrolls) { row.setAttribute('tabindex', '0'); row.setAttribute('role', 'region'); row.setAttribute('aria-label', 'Muse in numbers (scrolls sideways)'); }
      else { row.removeAttribute('tabindex'); row.removeAttribute('role'); row.removeAttribute('aria-label'); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tiles); else tiles();
  window.addEventListener('resize', tiles);

  // Product card photos (shared section): sharp on 2x screens, on this page only. Opal: the Files original is 1080px but
  // the card's srcset stops at 800w, so add 1080w. Muse 2: the Files image is 680x520; the same picture at 1360x1040
  // (Figma export d07-headband@2x) ships as theme assets. The section's colour switch restores src/srcset from
  // data-default-src(set), so those are updated too. A different image in the settings is left alone.
  function cardImages() {
    var m2 = document.querySelector('[data-ba-card-muse2]');
    document.querySelectorAll('[id^="shopify-section-template"] .pps-image').forEach(function (img) {
      var base = img.dataset.defaultSrc || img.getAttribute('src') || '';
      if (/ProductCard-Opal/.test(base)) {
        var set = (img.dataset.defaultSrcset || img.getAttribute('srcset') || '').replace(/\s+/g, ' ').trim();
        if (!set || / 1080w/.test(set)) return;
        img.dataset.defaultSrcset = set.replace(/,\s*$/, '') + ', ' + base.replace(/([?&])width=\d+/, '$1width=1080') + ' 1080w';
        if (img.hasAttribute('srcset')) img.setAttribute('srcset', img.dataset.defaultSrcset);
      } else if (/Image_Modification_Request_1/.test(base) && m2) {
        var x1 = m2.getAttribute('data-ba-card-muse2'), x2 = m2.getAttribute('data-ba-card-muse2-2x');
        img.dataset.defaultSrc = x1;
        img.dataset.defaultSrcset = x1 + ' 680w, ' + x2 + ' 1360w';
        img.setAttribute('src', x1);
        img.setAttribute('srcset', img.dataset.defaultSrcset);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cardImages); else cardImages();

  // Product card: keep focus on the selected tab in the copy that is shown after the swap
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.pps-tab');
    if (!tab || !locationOf(tab)) return;
    var target = tab.getAttribute('data-switch-to');
    var card = tab.closest('.pps-view') && tab.closest('.pps-view').parentNode;
    // After the section's own click and keydown handlers. The card being shown fades in from visibility: hidden, and
    // focus() does nothing until its transition has started, so try again for up to half a second.
    var tries = 0;
    setTimeout(function settle() {
      var shown = card && card.querySelector('.pps-view.is-active');
      var same = shown && shown.querySelector('.pps-tab[data-switch-to="' + target + '"]');
      var a = document.activeElement;
      var lost = !a || a === document.body || (a.closest && a.closest('.pps-view') && !a.closest('.pps-view.is-active'));
      if (same && a !== same && (lost || (a.classList && a.classList.contains('pps-tab')))) same.focus({ preventScroll: true });
      if (same && document.activeElement !== same && ++tries < 10) setTimeout(settle, 50);
    }, 0);
  });
})();
